// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";
import {mantineStylesApiSchema} from "./primitives.zod";

export const mantineCardPropsSchema = z.strictObject({
	styles: mantineStylesApiSchema.optional(),
});
